import { useState } from "react";
import { Box, Chip, Paper, Typography } from "@mui/material";
import LookupChip from "./LookupChip";
import { useLookupColorMaps } from "../hooks/useLookups";

export default function TimelineCard({
  initiative,
  onClick,
  draggable,
  onDragStart,
  onDragEnd,
  isDragging,
}) {
  const { horizonColors, statusColors, priorityColors } = useLookupColorMaps();
  const horizonColor = horizonColors[initiative.horizon] || "primary.main";
  const [isHovered, setIsHovered] = useState(false);

  const styles = {
    card: {
      p: 1,
      borderLeft: 4,
      borderLeftColor: horizonColor,
      cursor: "pointer",
      bgcolor: "background.tableBody",
      transition: "box-shadow 0.15s ease, transform 0.15s ease",
    },
    hoveredCard: { boxShadow: 3, transform: "translateY(-2px)" },
    archivedCard: { opacity: 0.6 },
    draggingCard: { opacity: 0.4 },
    title: {
      fontWeight: 600,
      mb: 0.5,
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
    chipsRow: { display: "flex", gap: 0.5, flexWrap: "wrap" },
    chip: { height: 18, fontSize: "0.65rem" },
  };

  return (
    <Paper
      variant="outlined"
      onClick={() => onClick(initiative)}
      draggable={draggable}
      onDragStart={(e) => onDragStart?.(e, initiative)}
      onDragEnd={() => {
        onDragEnd();
        setIsHovered(false);
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      sx={[
        styles.card,
        isHovered ? styles.hoveredCard : null,
        initiative.archived ? styles.archivedCard : null,
        isDragging ? styles.draggingCard : null,
      ]}
    >
      <Typography variant="body2" sx={styles.title}>
        {initiative.title}
      </Typography>
      <Box sx={styles.chipsRow}>
        <LookupChip
          label={initiative.status}
          hex={statusColors[initiative.status]}
          sx={styles.chip}
        />
        <LookupChip
          label={initiative.priority}
          hex={priorityColors[initiative.priority]}
          variant="outlined"
          sx={styles.chip}
        />
        {initiative.product?.map((product) => (
          <LookupChip
            key={product}
            label={product}
            variant="outlined"
            sx={styles.chip}
          />
        ))}
        {initiative.archived && (
          <Chip
            label="Archived"
            size="small"
            color="archived"
            sx={styles.chip}
          />
        )}
      </Box>
    </Paper>
  );
}
